export const DEFAULT_RETRY_OPTIONS = { interval: 1000, retries: 5 };

// KU – adapted from https://stackoverflow.com/a/58078218
export function retryPromise<T>(promise: () => Promise<T>, options = DEFAULT_RETRY_OPTIONS) {
  const retries = (Number(options?.retries) || DEFAULT_RETRY_OPTIONS.retries) - 1;
  const interval = Number(options?.interval) || DEFAULT_RETRY_OPTIONS.interval;

  return new Promise<T>((resolve, reject) => {
    promise()
      .then(resolve)
      .catch(error => {
        if (retries <= 0) {
          reject(error);
          return;
        }
        setTimeout(() => {
          retryPromise(promise, {
            retries,
            interval,
          }).then(resolve, reject);
        }, interval);
      });
  });
}
type FetchParams = Parameters<typeof window.fetch>;

export function fetchWithRetry(
  url: FetchParams[0],
  options: FetchParams[1],
  retryOptions = DEFAULT_RETRY_OPTIONS,
) {
  return retryPromise(() => fetch(url, options), retryOptions);
}
